module.exports = __webpack_public_path__ + "img/lnk-report.3ea0eecd.svg";